import { Component } from "react"

/* Router */
import withRouter from "./withRouter"


/* Helper ScrollToTop — a page which was opened starts from its top and not from the place the
   previous one was scrolled to */
class ScrollToTop extends Component {

    componentDidMount = () => {
        window.scrollTo(0, 0)
    }

    componentDidUpdate = previous => {

        /* Another page was opened */
        if (previous.location.pathname !== this.props.location.pathname) {
            window.scrollTo(0, 0)
        }
    }

    render = () => null
}

export default withRouter(ScrollToTop)
